import React, { useEffect } from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useLocation } from "react-router-dom";
export default function LabelsOptions({
  more_filters = false,
  register,
  userLabels,
  setValue,
  watch,
}) {
  const location = useLocation();
  useEffect(() => {
    // Get query parameters from the URL
    const searchParams = new URLSearchParams(location.search);
    const labelsIncludesArrFromUrl = searchParams.get("labels_includes_arr");
    const labelsExcludesArrFromUrl = searchParams.get("labels_excludes_arr");

    if (labelsIncludesArrFromUrl) {
      setValue("labels_includes_arr", labelsIncludesArrFromUrl.split(","));
    }

    if (labelsExcludesArrFromUrl) {
      setValue("labels_excludes_arr", labelsExcludesArrFromUrl.split(","));
    }
  }, []);
  const labelsIncludesArr = watch("labels_includes_arr") || [];
  const labelsExcludesArr = watch("labels_excludes_arr") || [];

  const handleIncludeChange = (labelName) => {
    let updatedIncludes = [...labelsIncludesArr];

    if (updatedIncludes.includes(labelName)) {
      updatedIncludes = updatedIncludes.filter((label) => label !== labelName);
    } else {
      updatedIncludes.push(labelName);
    }

    // If this label was checked in "Exclude", remove it from "Exclude"
    if (labelsExcludesArr.includes(labelName)) {
      setValue(
        "labels_excludes_arr",
        labelsExcludesArr.filter((label) => label !== labelName)
      );
    }

    // Update the form state with the new array of includes
    setValue("labels_includes_arr", updatedIncludes);
  };

  const handleExcludeChange = (labelName) => {
    let updatedExcludes = [...labelsExcludesArr];

    if (updatedExcludes.includes(labelName)) {
      updatedExcludes = updatedExcludes.filter((label) => label !== labelName);
    } else {
      updatedExcludes.push(labelName);
    }

    // If this label was checked in "Include", remove it from "Include"
    if (labelsIncludesArr.includes(labelName)) {
      setValue(
        "labels_includes_arr",
        labelsIncludesArr.filter((label) => label !== labelName)
      );
    }

    // Update the form state with the new array of excludes
    setValue("labels_excludes_arr", updatedExcludes);
  };

  return (
    <>
      <div className="form_blk margin-top-neg">
        <h6 className="f_s_14 f_dim_light">Labels</h6>
        {more_filters ? (
          <>
            <ReactTooltip
              id="user-labels"
              place="bottom"
              content="Write label name manually or select among your stored labels to find properties which have these labels."
            />
            <div className="info_span" data-tooltip-id="user-labels">
              <span className="ic_on">
                <img src="/images/info-circle.svg" alt="" />
              </span>
            </div>
          </>
        ) : (
          ""
        )}

        <input
          type="text"
          className="input"
          id="labels_text"
          name="labels_text"
          placeholder="Search for label"
          {...register("labels_text")}
        />
      </div>
      <div className="form_blk margin-top-neg lbl_table_search">
        <table>
          <thead>
            <tr>
              <th>Labels</th>
              <th>Includes</th>
              <th>Exclude</th>
            </tr>
          </thead>
          <tbody>
            {userLabels.map((label) => (
              <tr key={label.label_name}>
                <td
                  className="lbl_dot blue_dot"
                  style={{
                    backgroundColor: label.label_color,
                  }}
                >
                  {label.label_name}
                </td>
                <td>
                  <input
                    type="checkbox"
                    name="labels_includes_arr"
                    checked={labelsIncludesArr.includes(label.label_name)}
                    onChange={() => handleIncludeChange(label.label_name)}
                  />
                </td>
                <td>
                  <input
                    type="checkbox"
                    name="labels_excludes_arr"
                    checked={labelsExcludesArr.includes(label.label_name)}
                    onChange={() => handleExcludeChange(label.label_name)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
